import Vue from 'vue'
import Vuex from 'vuex'
import { getLeftMenuList, getUserInfo, getOrgInfo, getPhoneSubmenu, getSysnoticeDetail } from "../api";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userInfo: null,
        orgInfo: null,
        leftMenuList: [],
        breadcrumb: [],
        phoneSubmenu: [],
        leftBarStatus: true,
        sysDetail: null
    },
    mutations: {
        SET_LEFT_SUBMENU: (state, phoneSubmenu) => {
            state.phoneSubmenu = phoneSubmenu
        },
        SET_LEFT_MENU_LIST: (state, leftMenuList) => {
            for (const menu of leftMenuList) {
                let include = globalRouter.options.routes.some((route) => {
                    return menu.url.includes(route.name)
                })
                if (include) {
                    menu.url = '/' + menu.url.replace('.html', '')
                } else {
                    menu.url = '/wlxy/admin/' + menu.url
                }
            }
            leftMenuList.forEach(item => {
                if (item.url === "/pcard") {
                    item.subItem = [{
                        url: '/pcard/manage',
                        show: true,
                        name: '实体卡片管理'
                    }, {
                        url: '/pcard/introduce',
                        show: true,
                        name: '实体卡说明'
                    }]
                } else if (item.url === "/card") {
                    item.subItem = [{
                        url: '/card/manage',
                        show: true,
                        name: '卡片管理'
                    }
                  ]
                  if(state.orgInfo.ecardStatus) {
                    item.subItem.push({
                        url: '/card/package',
                        show: true,
                        name: '卡包设置'
                    })
                  }
                  if(state.orgInfo.miniCampusStatus) {
                    item.subItem.push({
                        url: '/card/face',
                        show: true,
                        name: '卡面设置'
                    })
                  }
                }  else if (item.url === "/phone") {
                    item.subItem = [{
                        url: '/phone/name',
                        show: state.phoneSubmenu.phonelist,
                        name: '名单管理'
                    }, {
                        url: '/phone/pool',
                        show: state.phoneSubmenu.phonepool,
                        name: '号池管理'
                    }, {
                        url: '/phone/number',
                        show: state.phoneSubmenu.phone,
                        name: '手机号管理'
                    }]
                }
            })
            state.leftMenuList = leftMenuList
        },
        SET_USER_INFO: (state, info) => {
            state.userInfo = info
        },
        SET_ORG_INFO: (state, info) => {
            state.orgInfo = info
        },
        SET_LEFT_BAR_STATUS: (state, status) => {
            state.leftBarStatus = status
        },
        SET_BREADCRUMB: (state, breadcrumb) => {
            state.breadcrumb = breadcrumb
        },
        SET_SYS_DETAIL: (state, detail) => {
            state.sysDetail = detail
        },
    },
    actions: {
        async FETCH_LEFT_SUBMENU({ commit, dispatch, state, rootState, getters }) {
            let phoneSubmenu = await getPhoneSubmenu();
            commit('SET_LEFT_SUBMENU', phoneSubmenu)
        },
        async FETCH_LEFT_MENU_LIST({ commit, dispatch, state, rootState, getters }) {
            let leftMenuList = await getLeftMenuList();
            commit('SET_LEFT_MENU_LIST', leftMenuList)
        },
        async FETCH_USER_INFO({ commit, dispatch, state, rootState, getters }) {
            let userInfo = await getUserInfo();
            commit('SET_USER_INFO', userInfo)
        },
        async FETCH_ORG_INFO({ commit, dispatch, state, rootState, getters }) {
            let orgInfo = await getOrgInfo();
            commit('SET_ORG_INFO', orgInfo)
        },
        async FETCH_SYS_DETAIL({ commit, dispatch, state, rootState, getters }) {
            let sysDetail = await getSysnoticeDetail();
            commit('SET_SYS_DETAIL', sysDetail)
        },

    },
    getters: {
        // cityCode(state, getters) {
        //     return state.city.cityCode
        // },
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js